import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M24 4.17A4.19 4.19 0 0 0 19.83 0H4.17A4.19 4.19 0 0 0 0 4.17v15.66A4.19 4.19 0 0 0 4.17 24h15.66A4.19 4.19 0 0 0 24 19.83ZM19.41 17.5h-3.5a2 2 0 0 1-1.41-.59l-6.12-6.12a1 1 0 0 0-.71-.29H4.41a1 1 0 0 1 0-2h3.68a2 2 0 0 1 1.41.59l6.12 6.12a1 1 0 0 0 .71.29h3.08a1 1 0 0 1 0 2m0-7H14.5a1 1 0 0 1 0-2h4.91a1 1 0 0 1 0 2"
    }, null, -1)
  ]));
}
const computerKeyboardOption = { render };
export {
  computerKeyboardOption as default,
  render
};
//# sourceMappingURL=computer-keyboard-option.svg.js.map
